import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantService } from '../services/tenant.service';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {
  constructor(private tenantService: TenantService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tenantId = this.tenantService.tenantId;

    if (tenantId) {
      const clonedRequest = request.clone({
        setHeaders: {
          'X-Tenant-ID': tenantId
        }
      });
      return next.handle(clonedRequest);
    }

    return next.handle(request);
  }
}
